import React, { ForwardedRef } from 'react'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import UnverifiedUserIcon from '@mui/icons-material/Cancel'
import { useFragment } from 'react-relay'
import { graphql } from 'relay-runtime'
import { StatusField_User$key } from '__generated__/StatusField_User.graphql'
import useStyles from './styles'

export interface IStatusFieldProps {
  editable: boolean
  user: StatusField_User$key
}

function StatusField({ editable, user: userFragmentRef }: IStatusFieldProps, ref: ForwardedRef<HTMLDivElement>) {
  const { classes } = useStyles()

  const user = useFragment(graphql`
    fragment StatusField_User on User {
      status
    }
  `, userFragmentRef)

  const status = user?.status

  if (editable && status !== 'accepted' && status !== 'applied') {
    // only show verified (or pending verification) badge after they already applied for verification
    return null
  }

  if (status === 'accepted') {
    return (
      <div ref={ref} className={classes.verified} data-cy="verification-badge-verified">
        <VerifiedUserIcon className={classes.statusIcon} />Verified
      </div>
    )
  }

  if (status === 'applied') {
    return (
      <div ref={ref} className={classes.verified} data-cy="verification-badge-unverified">
        <VerifiedUserIcon className={classes.statusIcon} />Verification Pending
      </div>
    )
  }

  return (
    <div ref={ref} className={classes.unverified} data-cy="verification-badge-unverified">
      <UnverifiedUserIcon className={classes.statusIcon} />Unverified
    </div>
  )
}

export default React.memo(React.forwardRef(StatusField))
